import { useState } from 'react';
import { motion, AnimatePresence, type Variants } from 'framer-motion';
import shared from '../../styles/shared.module.css';
import styles from './PortfolioSection.module.css';
import { fadeUp } from '../../animations';

import headingPortfolio from '../../assets/figma/page13/heading-portfolio.png';
import facePink from '../../assets/figma/page13/face-pink.png';

const galleryVariant: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: 'easeOut', staggerChildren: 0.06 },
  },
};

const galleryItemVariant: Variants = {
  hidden: { opacity: 0, scale: 0.94 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.35, ease: 'easeOut' } },
};

const doodlePop: Variants = {
  hidden: { opacity: 0, scale: 0.4, rotate: -12 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: { type: 'spring', stiffness: 260, damping: 16 },
  },
};

const FILTERS = ['Todos', 'Quartos', 'Brinquedotecas', 'Espaços Comerciais'];

const Q = '/images/QUARTOS/QUARTOS/';
const B = '/images/BRINQUEDOTECAS/BRINQUEDOTECAS/';
const C = '/images/COMERCIAIS/COMERCIAIS/';
const T = '/images/TODOS/TODOS/';

const projects = [
  { title: 'Quarto Ayla', category: 'Quartos', image: `${Q}AYLA_1.jpg` },
  { title: 'Quarto Sophia e Helena', category: 'Quartos', image: `${Q}CENA 01 - QUARTO SOPHIA E HELENA AJUSTADA.jpg` },
  { title: 'Quarto infantil', category: 'Quartos', image: `${Q}IMG_8665.jpeg` },
  { title: 'Quarto Maria', category: 'Quartos', image: `${Q}MARIA_ALT_3_PAPEL.png` },
  { title: 'Quarto Nicolas', category: 'Quartos', image: `${Q}NICOLAS_1.jpg` },
  { title: 'Quarto cena 03', category: 'Quartos', image: `${Q}POS QUARTO CENA 03.jpg` },
  { title: 'Quarto Helena', category: 'Todos', image: `${T}HELENA_ALT_1.png` },
  { title: 'Quarto Heloísa', category: 'Todos', image: `${T}HELOISA_Cena3.jpg` },
  { title: 'Consultoria Quarto Luísa', category: 'Todos', image: `${T}CONSULTORIA-Quarto-Luisa-(1)_Cena4.jpg` },
  { title: 'Quarto filhos', category: 'Todos', image: `${T}POS QUARTO FILHOS - CENA 04.jpg` },
  { title: 'Projeto cena atualizada', category: 'Todos', image: `${T}CENA 03 -ATUALIZADA.jpg` },
  { title: 'Projeto especial', category: 'Todos', image: `${T}IMG-8973.JPG` },
  { title: 'Brinquedoteca cena 01', category: 'Brinquedotecas', image: `${B}1650560968888_BRINQUEDOTECA_CENA 01 POS.jpg` },
  { title: 'Brinquedoteca Mada', category: 'Brinquedotecas', image: `${B}BRINQ_MADA_4.jpg` },
  { title: 'Brinquedoteca loja', category: 'Brinquedotecas', image: `${B}LOJA POS 03.jpg` },
  { title: 'Brinquedoteca 02', category: 'Brinquedotecas', image: `${B}POS BRINQUEDOTECA 02.jpg` },
  { title: 'Brinquedoteca ângulo', category: 'Brinquedotecas', image: `${B}PÓS ANGULO 03 - BRINQUEDOTECA 25.01.jpg` },
  { title: 'Sala VIP', category: 'Brinquedotecas', image: `${B}SALA VIP 02.png` },
  { title: 'Espaço comercial', category: 'Espaços Comerciais', image: `${C}IMG-2175.JPG` },
  { title: 'Ambiente comercial', category: 'Espaços Comerciais', image: `${C}IMG_1183.jpeg` },
  { title: 'Meninice', category: 'Espaços Comerciais', image: `${C}MENINICE_1.jpg` },
  { title: 'Salão', category: 'Espaços Comerciais', image: `${C}SALÃO 02.png` },
  { title: 'Fachada', category: 'Espaços Comerciais', image: `${C}fachada final.jpg` },
  { title: 'Espaço kids', category: 'Espaços Comerciais', image: `${C}image_1(1).JPG` },
];

export function PortfolioSection() {
  const [activeFilter, setActiveFilter] = useState(FILTERS[0]);
  const visibleProjects = projects.filter((p) => p.category === activeFilter);

  return (
    <section id="portfolio" className={styles.portfolio}>
      <motion.img
        src="/ciranda.svg"
        alt=""
        aria-hidden="true"
        className={styles.cirandaRibbon}
        variants={doodlePop}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      />
      <motion.img
        src={facePink}
        alt=""
        aria-hidden="true"
        className={styles.facePink}
        variants={doodlePop}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      />
      {/* Assets exclusivos do mobile (≤768px) — posições/tamanhos no bloco
          "ASSETS MOBILE" do PortfolioSection.module.css */}
      <motion.img
        src="/laco-amarelo.svg"
        alt=""
        aria-hidden="true"
        className={styles.lacoAmarelo}
        variants={doodlePop}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      />
      <motion.img
        src="/rosto-rosa.svg"
        alt=""
        aria-hidden="true"
        className={styles.rostoRosa}
        variants={doodlePop}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      />

      <div className={shared.frame}>
        <motion.div
          className={styles.portfolioHeader}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className={`${shared.assetHeading} ${styles.portfolioHeading}`}>
            <img src={headingPortfolio} alt="Portfólio" />
          </h2>
          <p className={styles.portfolioSubtitle}>
            Ambientes que <strong>inspiram e transformam.</strong>
          </p>
          <p>
            Projetamos ambientes que nutrem a criatividade, promovem o bem-estar e moldam o futuro
            das crianças.
          </p>
        </motion.div>

        <div className={styles.filters} aria-label="Filtros de portfólio">
          {FILTERS.map((filter) => (
            <button
              key={filter}
              type="button"
              className={`${styles.filterPill} ${activeFilter === filter ? styles.filterActive : ''}`}
              aria-pressed={activeFilter === filter}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            className={styles.gallery}
            key={activeFilter}
            variants={galleryVariant}
            initial="hidden"
            animate="visible"
            exit={{ opacity: 0, transition: { duration: 0.2 } }}
          >
            {visibleProjects.map((project) => (
              <motion.article
                className={styles.projectCard}
                key={project.image}
                variants={galleryItemVariant}
                whileHover={{ scale: 1.03 }}
                transition={{ type: 'spring', stiffness: 300, damping: 22 }}
              >
                <img src={project.image} alt={project.title} />
              </motion.article>
            ))}
            {/* Rosto laranja no mobile: absoluto dentro da galeria, entre a 2ª e a
                3ª linha do grid — ajustes no bloco "ASSETS MOBILE" do module.css.
                Herda o stagger da galeria, então dá o "pop" a cada troca de filtro */}
            <motion.img
              src="/rosto-laranja.svg"
              alt=""
              aria-hidden="true"
              className={styles.rostoLaranja}
              variants={doodlePop}
            />
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}
